import { Suspense } from 'react';
import { withTheme } from 'web-ui-kit/dist/hoc/with-theme';

import AppLoginFlow from 'app/app-login-flow';
import AppRegisterFlow from 'app/app-register-flow';
import AppResetPasswordFlow from 'app/app-reset-password-flow';
import AppPageExpiredFlow from 'app/app-page-expired-flow';
import AppErrorFlow from 'app/app-error-flow';
import KeycloakFallback from 'app/app-fallback';

import { kcContext } from 'config/kc-context';

import 'services/i18n';
import 'services/journal';

import 'scss/app.scss';
import 'web-ui-kit/scss/colors.scss';

function App() {
  return (
    <Suspense>
      {(() => {
        switch (kcContext.pageId) {
          case 'login.ftl':
            return <AppLoginFlow {...kcContext} />;
          case 'register.ftl':
            return <AppRegisterFlow {...kcContext} />;
          case 'login-reset-password.ftl':
            return <AppResetPasswordFlow {...kcContext} />;
          case 'error.ftl':
            return <AppErrorFlow {...kcContext} />;
          case 'login-page-expired.ftl':
            return <AppPageExpiredFlow />;
          default:
            return <KeycloakFallback />;
        }
      })()}
    </Suspense>
  );
}

export default withTheme(App);
